import EmiComponent from "./EmiComponent";
import { useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLeadProcessingEmiDetails } from '../../src/store/slices/insurance';
import { useParams } from "react-router-dom";
import * as HELPER from "../../src/config/helper";
import {AGENT_LEAD_TYPES,COUNTRY_CODE,APP_COUNTRY} from '../config/constant'
import FullPageLoader from '../../src/common/FullPageLoader';
import LeadDetailFormID from './LeadDetailFormId';
import moment from 'moment';

const getAmountInCents = (value: any) => {
  if (value === null || value === undefined || value === "") return 0;
  const amount = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
};

const isEmiCompleted = (emi: any) => {
  const expectedAmount = emi?.installment_expected_amount ?? emi?.total_premium;
  const expectedAmountInCents = getAmountInCents(expectedAmount);
  return expectedAmountInCents > 0 && getAmountInCents(emi?.received_amount) >= expectedAmountInCents;
};

const LeadFiledTabs = (props: any) => {
  const { id } = useParams<{ id: string }>()
  const dispatch: any = useDispatch();
  const insuranceDetails = useSelector((state: any) => state.insurance.leadEmiDetail);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [IsFromXendit,setIsFromXendit] = useState<boolean>(true);
  const [IsPaymentFromAgent,setIsPaymentFromAgent] = useState<boolean>(false);
  const [isPushedToRemittance, setIsPushedToRemittance] = useState<boolean>(false);
  const isLeadDetailLoaderControlled = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && typeof props.setLeadDetailLoading === 'function';

  const isTruthyFlag = (value: any) => value === true || value === 1 || value === "1";
  const setPageLoading = (isLoading: boolean) => {
    if (isLeadDetailLoaderControlled) {
      props.setLeadDetailLoading(isLoading);
      return;
    }

    setLoading(isLoading);
  };

  const loadLeadEmiDetails = async () => {
    if (id) {
      setPageLoading(true);  // start loader
    try {
      await dispatch(fetchLeadProcessingEmiDetails({ id }));
    } catch (error) {
      console.error("Error fetching EMI details:", error);
    } finally {
      setPageLoading(false); // stop loader always
    }
  }
  };
  useEffect(() => {
    // const isEmpty = !insuranceDetails || Object.keys(insuranceDetails).length === 0;
    // && isEmpty
    loadLeadEmiDetails();
    // eslint-disable-next-line
  }, [id,props.callReloadApi]);
  // // insuranceDetails

  useEffect(() => {
    const loadAndSetTab = async () => {
      const details = insuranceDetails?.emi_details || [];
      if (details.length > 0) {
        // Check if all EMIs are completed
        const allCompleted = details.every((emi: any) => isEmiCompleted(emi));
        if (allCompleted) {
          setSelectedTab(details.length - 1); // Last tab
        } else {
          // Find the first unpaid EMI
          const nextPendingIndex = details.findIndex((emi: any) => !isEmiCompleted(emi));
          setSelectedTab(nextPendingIndex !== -1 ? nextPendingIndex : 0);
        }
      }
    };
    loadAndSetTab();
    // eslint-disable-next-line
  }, [insuranceDetails]);

  useEffect(() => {
    const emiData = insuranceDetails;
    setIsFromXendit(isTruthyFlag(emiData?.is_from_xendit));
    setIsPaymentFromAgent(Number(emiData?.payment_from) === 1);
    setIsPushedToRemittance(isTruthyFlag(emiData?.isPushInRemittance));
    // Check if lead is fully paid
    const isLeadCompletelyPaid = Number(emiData?.received_amount || 0) >= Number(emiData?.total_premium || 0);
    
    // First successful payment sent to Finance/Reco
    const isFirstPaymentSent = (emiData?.emi_details || []).some((emi: any) => (emi?.Payments || []).some( (p: any) => Number(p.received_amount) > 0 &&
          (emiData?.is_payment_method_check ? !!p.assigned_finance_id : !!p.assigned_reco_id))
    );
    if(isLeadCompletelyPaid){
      props.setIsReferralButtonDisabled(true);
    }else if (isFirstPaymentSent) {
      props.setIsReferralButtonDisabled(false);
    }
    // eslint-disable-next-line
  }, [insuranceDetails]);


  const emiDetails = insuranceDetails?.emi_details || [];
  const isInstallments = insuranceDetails?.is_installments;
  const isPaymentMethodChecq = insuranceDetails?.is_payment_method_check;
  const isPaymentTypeShow = AGENT_LEAD_TYPES.includes(insuranceDetails?.application_type_id);
  const isWholeLeadPaymentDone = Number(insuranceDetails?.received_amount || 0) >= Number(insuranceDetails?.total_premium || 0);
  props.setLeadFromAgency(isPaymentTypeShow);
  
  const leadSubStatusId = insuranceDetails?.sub_status_id || 0
  const OVERPAID_INDEX = emiDetails.length;
  const overpaidPayments = insuranceDetails?.overpaid_payments || [];
  const overpaidAmount = insuranceDetails?.overpaid_amount ?? 0;
  const shouldShowOverpaidAmount = getAmountInCents(overpaidAmount) > 0;
  const isOverpaidTab = shouldShowOverpaidAmount && selectedTab === OVERPAID_INDEX;
  // const activeEmiData = isInstallments ? emiDetails[selectedTab] : insuranceDetails;
  const activeEmiData = isOverpaidTab ? { ...(insuranceDetails || {}), Payments: overpaidPayments } : emiDetails[selectedTab] || emiDetails[0];
  return (
    <>
      {!isLeadDetailLoaderControlled && <FullPageLoader show={loading} />}
      <div className="lead-detail-tabs">
        <div className="detail-form-sec">
          {/* isInstallments &&  */}
          {
            COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH &&
            <div className="menu-tab-left-panel">
              <div className="dealer-tab-left-panel nav">
                <ul>
                  {emiDetails.map((emi:any, index:number) => {
                    const isCompleted = isEmiCompleted(emi);
                    const isActive = selectedTab === index;
                    const tabLabel = isInstallments
                      ? `${HELPER.getOrdinal(emi.installment_no)} EMI`
                      : "Payment Details";
                    const dueDateLabel = emi.installment_expected_date
                      ? moment(emi.installment_expected_date).isValid()
                        ? moment(emi.installment_expected_date).format("DD MMM, YYYY")
                        : emi.installment_expected_date
                      : "";
                    
                    return (
                      <li key={index}>
                        <a href=":" className={`${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setSelectedTab(index);
                          }}
                        >
                          <span className="img-type"></span>
                          {tabLabel}
                          {
                            isInstallments && emi.installment_expected_date && ` - ${emi.installment_expected_date}`
                          }
                          {
                            !isInstallments && dueDateLabel && ` - ${dueDateLabel}`
                          }
                          
                        </a>
                      </li>
                    );
                  })}
                  {/* OverPaid Tab */}
                  {shouldShowOverpaidAmount && (
                    <li key="overpaid">
                      <a
                        href=":"
                        className={isOverpaidTab ? "active" : ""}
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab(OVERPAID_INDEX);
                        }}
                      >
                        <span className="img-type"></span>
                        <span style={{ display: "inline-block", verticalAlign: "top" }}>
                          <span>Overpaid Amount</span>
                          <span className="d-block">{HELPER.addCurrencyFormatting(overpaidAmount)}</span>
                        </span>
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          }

          <div className="route-files">
            {
              COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH ? 
              <EmiComponent emiData={activeEmiData} isInstallments={isInstallments} isPaymentMethodChecq={isPaymentMethodChecq} 
              reloadEmiDetails={loadLeadEmiDetails} totalEmildetail={emiDetails} selectedIndex={selectedTab} isPaymentTypeShow={isPaymentTypeShow} isWholeLeadPaymentDone={isWholeLeadPaymentDone} leadDetail={insuranceDetails} setCallReloadApi = {props.setCallReloadApi}  callReloadApi = {props.callReloadApi} leadSubStatusId={leadSubStatusId} isOverpaidTab={isOverpaidTab} setLeadDetailLoading={isLeadDetailLoaderControlled ? props.setLeadDetailLoading : undefined}/>
              :
              <LeadDetailFormID IsFromXendit={IsFromXendit} IsPaymentFromAgent={IsPaymentFromAgent} paymentConfig={insuranceDetails} reloadEmiDetails={loadLeadEmiDetails} isPushedToRemittance={isPushedToRemittance} leadSubStatusId={leadSubStatusId}/>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadFiledTabs;
